// extracted by mini-css-extract-plugin
export default {"main":"styles_main__OoLSc","side_nav":"styles_side_nav__NBD8x","active":"styles_active__p6gT2"};